import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper } from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MaterialTable from 'material-table'
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ls from 'local-storage'
import moment from 'moment';

import {ResponsiveContainer, ComposedChart, Line, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';

import Clear from "@material-ui/icons/Clear";
import Add from "@material-ui/icons/Add";
import Check from "@material-ui/icons/Check";
import Delete from "@material-ui/icons/DeleteOutline";
import DetailPanel from "@material-ui/icons/ChevronRight";
import Edit from "@material-ui/icons/Edit";
import Export from "@material-ui/icons/SaveAlt";
import Filter from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import NextPage from "@material-ui/icons/ChevronRight";
import PreviousPage from "@material-ui/icons/ChevronLeft";
import ResetSearch from "@material-ui/icons/Clear";
import Search from "@material-ui/icons/Search";
import ThirdStateCheck from "@material-ui/icons/Remove";
import ViewColumn from "@material-ui/icons/ViewColumn";

const tableIcons = {
    Add: () => <Add/>,
    Check: () => <Check/>,
    Clear: () => <Clear/>,
    Delete: () => <Delete/>,
    DetailPanel: () => <DetailPanel/>,
    Edit: () => <Edit/>,
    Export: () => <Export/>,
    Filter: () => <Filter/>,
    FirstPage: () => <FirstPage/>,
    LastPage: () => <LastPage/>,
    NextPage: () => <NextPage/>,
    PreviousPage: () => <PreviousPage/>,
    ResetSearch: () => <ResetSearch/>,
    Search: () => <Search/>,
    ThirdStateCheck: () => <ThirdStateCheck/>,
    ViewColumn: () => <ViewColumn/>,
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabBar: {
    boxShadow: 'none',
    paddingTop: 8,
  },  
  paper: {
    padding: theme.spacing.unit,
    color: theme.palette.text.secondary,
  },
  paperTargets: {
    padding: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    backgroundColor: "#002140",
    color: "#ffffff",
  },
});

class ClaimsUDA extends React.Component {
    _isMounted = false;

    state = {
        value: 0,
        contract: '',
        performer: 'all',
        year: '2024-2025',
        month: 'all',
        clinicians: [],
        contracts: [],
        udadata: [],
    };

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MuiTableCell: {
                /*root: {
                    padding: 0,
                }*/
            }
        }
    }); 

    componentDidMount() {
        this._isMounted = true; 

        this.props.socket.emit("claim_clinicians",{authenticator:ls.get("authenticator")});
        this.props.socket.emit("get_contracts",{authenticator:ls.get("authenticator")});

        this.props.socket.on("claim_clinicians_result",(d)=>{
            if (this._isMounted) {
                this.setState({clinicians:d});
            }
        });         

        this.props.socket.on("contract_list",(d)=>{
            if (this._isMounted) {
                if (d) {
                    this.setState({contracts:d});
                    this.setState({contract:d[0]});
                } 

                this.sendSearch();              
            }
        }); 

        this.props.socket.on("uda_totals",(d)=>{
            if (this._isMounted) {
                //console.log(d);

                this.setState({udatotals:d.totals});
                this.setState({udatarget:d.target});

                let datatemp = [];
                let i = 0;
                for (i=0; i<d.totals.length; i++)
                {
                    let dtemp = d.totals[i];
                    /*dtemp.name = d.totals[i].date;
                    dtemp.claimed = d.totals[i].claimed_total;
                    dtemp.expected = d.totals[i].expected_total;
                    dtemp.confirmed = d.totals[i].confirmed_total;*/

                    if (this.state.month === 'all')
                        dtemp.target = (d.target/12)*(i+1);
                    else {
                        let mDays = moment(this.state.year.substr(0,4)+''+this.state.month, "YYYY-MM").daysInMonth();                        
                        dtemp.target = Math.floor(((d.target/12)/mDays)*(i+1));
                    }

                    datatemp.push(dtemp);
                }

                this.setState({udadata: datatemp});

            }
        });                     
    }

    handleChange = async (event) => {
        await this.setState({ [event.target.name]: event.target.value });
        this.sendSearch();
    };

    sendSearch = () => {
        //console.log('send search');
        let search = {};
        search.contract = this.state.contract;
        search.performer = this.state.performer;
        search.year = this.state.year;
        search.month = this.state.month;
        this.props.socket.emit("uda_figures",{search:search, authenticator:ls.get("authenticator")});
    }

    renderContractOptions() {
        if (this.state.contracts)
        {
            return this.state.contracts.map((dt, i) => {
                return (
                    <MenuItem
                    key={i}
                    value={dt}>
                    {dt}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }    

    renderDentistOptions() {
        if (this.state.clinicians)
        {
            return this.state.clinicians.map((dt, i) => {
                return (
                    <MenuItem
                    key={dt.staff_id}
                    value={dt.staff_id}>
                    {dt.displayname}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }    

    render() {
        const { classes } = this.props;
        const { udadata } = this.state;

        const columns=[
            { title: 'Date', field: 'date'},
            { title: 'Claimed', field: 'claimed'},
            { title: 'Claimed Total', field: 'claimed_total'},
            { title: 'Confirmed', field: 'confirmed'},
            { title: 'Confirmed Total', field: 'confirmed_total'},
            { title: 'Expected', field: 'expected'},
            { title: 'Expected Total', field: 'expected_total'},
            { title: 'No Reply Total', field: 'noreply_total'},
        ];         

        return (
        <div className={classes.root}>
            <Grid container style={{ padding: 2 }} spacing={1}>
                <Grid item xs={2}>
                    <Paper className={classes.paper}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <InputLabel htmlFor="uda-contract">Contract</InputLabel>
                            <Select
                            value={this.state.contract}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'contract',
                                id: 'uda-contract',
                            }}
                                >
                                {this.renderContractOptions()}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <InputLabel htmlFor="uda-performer">Performer</InputLabel>
                            <Select
                            value={this.state.performer}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'performer',
                                id: 'uda-performer',
                            }}
                                >
                                <MenuItem value="all">All Performers</MenuItem>
                                {this.renderDentistOptions()}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <InputLabel htmlFor="uda-year">Year</InputLabel>
                            <Select
                            value={this.state.year}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'year',
                                id: 'uda-year',
                            }}
                                >
                                <MenuItem value="2024-2025">2024-2025</MenuItem>
                                <MenuItem value="2023-2024">2023-2024</MenuItem>
                                <MenuItem value="2022-2023">2022-2023</MenuItem>
                                <MenuItem value="2021-2022">2021-2022</MenuItem>
                                <MenuItem value="2020-2021">2020-2021</MenuItem>
                                <MenuItem value="2019-2020">2019-2020</MenuItem>
                                <MenuItem value="2018-2019">2018-2019</MenuItem>
                                <MenuItem value="2017-2018">2017-2018</MenuItem>
                                <MenuItem value="2016-2017">2016-2017</MenuItem>
                                <MenuItem value="2015-2016">2015-2016</MenuItem>
                                <MenuItem value="2014-2015">2014-2015</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <InputLabel htmlFor="uda-month">Month</InputLabel>
                            <Select
                            value={this.state.month}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'month',
                                id: 'uda-month',
                            }}
                                >
                                <MenuItem value="all">All Months</MenuItem>
                                <MenuItem value="4">April</MenuItem>
                                <MenuItem value="5">May</MenuItem>
                                <MenuItem value="6">June</MenuItem>
                                <MenuItem value="7">July</MenuItem>
                                <MenuItem value="8">August</MenuItem>
                                <MenuItem value="9">September</MenuItem>
                                <MenuItem value="10">October</MenuItem>
                                <MenuItem value="11">November</MenuItem>
                                <MenuItem value="12">December</MenuItem>
                                <MenuItem value="1">January</MenuItem>
                                <MenuItem value="2">February</MenuItem>
                                <MenuItem value="3">March</MenuItem>
                            </Select>
                        </FormControl>
                    </Paper>
                    <Paper className={classes.paperTargets}>
                        <div>Year UDA Target: 0</div>
                        <div>Range UDA Target: {this.state.udatarget}</div>
                    </Paper>
                </Grid>
                <Grid item xs={10}>
                    <Paper className={classes.paper}>
                        <ResponsiveContainer width="100%" height={400}>
                            <ComposedChart data={udadata}
                                    margin={{top: 10, right: 30, left: 0, bottom: 0}}>
                                <CartesianGrid strokeDasharray="3 3"/>
                                <XAxis dataKey="date"/>
                                <YAxis/>
                                <Legend/>
                                <Tooltip/>
                                <Area type='monotone' dataKey='claimed_total' stroke='#ff0000' fill='#ff0000' />
                                <Area type='monotone' dataKey='confirmed_total' stroke='#82ca9d' stackId="1" fill='#82ca9d' />
                                <Area type='monotone' dataKey='expected_total' stroke='#8884d8' stackId="1" fill='#8884d8' />
                                <Line type='monotone' dataKey='target' stroke='#ffc658' fill='#ffc658' strokeWidth={2} />
                            </ComposedChart>
                        </ResponsiveContainer>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Paper>
                        <MuiThemeProvider theme={this.getMuiTheme()}>
                        <MaterialTable
                            columns={columns}
                            data={this.state.udatotals}
                            title="UDA Counts"
                            options={{
                                exportButton: true,
                            }}
                            icons={tableIcons}
                        />
                        </MuiThemeProvider> 
                    </Paper>            
                </Grid>                     
            </Grid>
        </div>
        );
    }
}

export default withStyles(styles)(ClaimsUDA);